import { yupResolver } from '@hookform/resolvers/yup';
import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
// material
import {
  Avatar,
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
// components
import Swal from 'sweetalert2';
import Iconify from '../components/Iconify';
import Label from '../components/Label';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../sections/@dashboard/user';
// mock
import AccountFilterSidebar from '../components/account/AccountFilterSidebar';
import { FormProvider, RHFTextField } from '../components/hook-form';
import { RHFSelect } from '../components/hook-form/RHFSelect';
import { AccountService } from '../Services/account.service';
import USERLIST from '../_mock/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Họ và tên', label_en: 'Full name', alignRight: false },
  { id: 'company', label: 'Tài khoản', label_en: 'Username', alignRight: false },
  { id: 'role', label: 'Quyền', label_en: 'Role', alignRight: false },
  { id: 'status', label: 'Trạng thái', label_en: 'Status', alignRight: false },
  { id: '' },
];

const Image = styled('img')({});

// ----------------------------------------------------------------------

export default function User() {
  const [page, setPage] = useState(0);

  const [totalUser, setTotalUser] = useState(0);

  const [pageSize, setPageSize] = useState(5);

  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [users, setUsers] = useState([]);

  const [editMode, setEditMode] = useState(false);

  const [selected, setSelected] = useState([]);

  const [selectedItem, setSelectedItem] = useState();

  const [createMode, setCreateMode] = useState();

  const [search, setSearch] = useState('');

  const [openFilter, setOpenFilter] = useState(false);

  const [filter, setFilter] = useState({
    role: '',
    status: '',
  });

  const typingTimeoutRef = useRef();

  const { t } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getAccountHandler();
  }, [page, pageSize, search, filter]);

  const getAccountHandler = () => {
    AccountService.GetAccounts({
      page,
      pageSize,
      search,
      ...filter,
    })
      .then((res) => {
        setTotalUser(res.pagination.count);
        setUsers(res.data);
      })
      .catch((err) => console.log({ err }));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      setSearch(value);
      setPage(0);
    }, 500);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleDelete = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: t('sure.title'),
      text: t('sure.delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('sure.yes'),
      cancelButtonText: t('sure.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AccountService.DeleteAccount(id)
          .then(() => {
            const newList = users.filter((user) => user._id !== id);
            setUsers(newList);
            Swal.fire(t('sure.success'), '', 'success');
          })
          .catch((err) => Swal.fire('Error!', err.response.data, 'error'));
      }
    });
  };

  const handleDisable = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: t('sure.title'),
      text: t('sure.disable'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('sure.yes'),
      cancelButtonText: t('sure.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AccountService.DisableAccount(id)
          .then(() => {
            const newList = users.map((user) => {
              if (user._id === id) user.status = 'Inactive';
              return user;
            });
            setUsers(newList);
            Swal.fire(t('sure.success'), '', 'success');
          })
          .catch((err) => Swal.fire('Error!', err.response.data, 'error'));
      }
    });
  };

  const handleEnable = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: t('sure.title'),
      text: t('sure.enable'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('sure.yes'),
      cancelButtonText: t('sure.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AccountService.EnableAccount(id)
          .then(() => {
            const newList = users.map((user) => {
              if (user._id === id) user.status = 'Active';
              return user;
            });
            setUsers(newList);
            Swal.fire(t('sure.success'), '', 'success');
          })
          .catch((err) => Swal.fire('Error!', err.response.data, 'error'));
      }
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * pageSize - users.length) : 0;

  const isUserNotFound = users.length === 0;

  const handleEdit = (item) => {
    setEditMode(true);
    setSelectedItem(item);
  };

  const handleOnEditClose = () => {
    setEditMode(false);
    setSelectedItem(null);
  };

  const handleEditSubmit = (data, image) => {
    const formData = new FormData();
    formData.append('fullname', data.fullname);
    formData.append('role', data.role);
    formData.append('phone', data.phone);
    formData.append('avatar', image);
    AccountService.EditAccount(selectedItem._id, formData)
      .then((res) => {
        const newData = users.map((item) => {
          if (item._id === res._id) {
            item.fullname = res.fullname;
            item.phone = res.phone;
            item.role = res.role;
            item.avatar = res.avatar;
          }
          return item;
        });
        setUsers(newData);
        setEditMode(false);
        setSelectedItem(null);
        enqueueSnackbar('Cập nhật thành công', { variant: 'success' });
      })
      .catch((err) => {
        enqueueSnackbar(err.response.data, { variant: 'error' });
      });
  };

  const handleOnCreateClick = () => {
    setCreateMode(true);
  };

  const handleOnCreateClose = () => {
    setCreateMode(false);
  };

  const handleOnCreateSubmit = (data, image) => {
    const formData = new FormData();
    formData.append('fullname', data.fullname);
    formData.append('role', data.role);
    formData.append('phone', data.phone);
    formData.append('avatar', image);
    formData.append('password', data.password);
    formData.append('passwordConfirmation', data.confirmPassword);
    formData.append('username', data.username);
    AccountService.CreateAccount(formData)
      .then((res) => {
        setUsers((prevState) => [res, ...prevState]);
        setCreateMode(false);
        enqueueSnackbar('Thêm tài khoản thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }));
  };

  return (
    <>
      {editMode && (
        <EditDialog item={selectedItem} isOpen={editMode} onClose={handleOnEditClose} editSubmit={handleEditSubmit} />
      )}

      {createMode && (
        <CreateDialog isOpen={createMode} onClose={handleOnCreateClose} createSubmit={handleOnCreateSubmit} />
      )}

      <Page title="User">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              {t('account.title')}
            </Typography>
            <Button variant="contained" onClick={handleOnCreateClick} startIcon={<Iconify icon="eva:plus-fill" />}>
              {t('account.create')}
            </Button>
          </Stack>

          <Card>
            <UserListToolbar
              numSelected={selected.length}
              onFilterName={handleSearchChange}
              onOpenFilter={handleOpenFilter}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    // order={order}
                    // orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    // rowCount={USERLIST.length}
                    // numSelected={selected.length}
                    // onRequestSort={handleRequestSort}
                    // onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {users.map((row, index) => {
                      return (
                        <TableRow hover key={row._id} tabIndex={-1} role="checkbox">
                          <TableCell width={60} align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              {row?.avatar?.match('https://') || row?.avatar === '' ? (
                                // <Avatar alt={row.name} src={`${process.env.PUBLIC_URL}${row.avatar}`} />
                                <Avatar alt={row.name} src={`/static/LogoAvatar.png`} />
                              ) : (
                                <Avatar
                                  alt={row.name}
                                  crossOrigin="anonymous"
                                  src={`${process.env.REACT_APP_IMAGE}${row.avatar}`}
                                />
                              )}
                              <Typography variant="subtitle2" noWrap>
                                {row.fullname}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">{row.username}</TableCell>
                          <TableCell align="left">{sentenceCase(row.role)}</TableCell>
                          {/* <TableCell align="left">{isVerified ? 'Yes' : 'No'}</TableCell> */}
                          <TableCell align="left">
                            <Label variant="ghost" color={(row.status === 'Inactive' && 'error') || 'success'}>
                              {sentenceCase(row.status)}
                            </Label>
                          </TableCell>

                          <TableCell align="right">
                            <UserMoreMenu
                              id={row._id}
                              item={row}
                              status={row.status}
                              handleDisable={handleDisable}
                              handleDelete={handleDelete}
                              handleEnable={handleEnable}
                              handleEdit={handleEdit}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalUser}
              rowsPerPage={pageSize}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
        <AccountFilterSidebar
          isOpenFilter={openFilter}
          onOpenFilter={handleOpenFilter}
          onCloseFilter={handleCloseFilter}
          filter={filter}
          setFilter={setFilter}
          setPage={setPage}
        />
      </Page>
    </>
  );
}

const EditDialog = ({ item, isOpen, onClose, editSubmit }) => {
  const [image, setImage] = useState();
  const [imageReview, setImagePreview] = useState();

  const { t } = useTranslation();

  const LoginSchema = Yup.object().shape({
    fullname: Yup.string().required('Username is required'),
    phone: Yup.string().required('....'),
  });

  const handleAvatarChange = (e) => {
    const img = e.target.files[0];
    const review = URL.createObjectURL(img);
    setImagePreview(review);
    setImage(img);
  };

  const defaultValues = {
    fullname: item?.fullname,
    phone: item?.phone,
    role: item?.role,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleOnSubmit = (data) => {
    editSubmit(data, image);
  };

  return (
    <Dialog fullWidth={Boolean(true)} maxWidth={'md'} open={isOpen}>
      <DialogTitle>{t('editForm.title')}</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} container justifyContent={'center'} alignItems={'center'}>
              <IconButton
                sx={{
                  width: '200px',
                  height: '200px',
                  overflow: 'hidden',
                  ':hover': {
                    bgcolor: 'transparent',
                  },
                }}
                color="default"
                aria-label="upload picture"
                component="label"
              >
                <input hidden accept="image/*" type="file" onChange={handleAvatarChange} />
                {imageReview && <Image sx={{ overflow: 'hidden' }} src={imageReview} />}
                {!imageReview && item?.avatar.match('https://') && (
                  <Image sx={{ overflow: 'hidden' }} src={`/static/noimage.jpeg`} />
                )}
                {!imageReview && !item?.avatar.match('https://') && (
                  <Image sx={{ overflow: 'hidden' }} src={`${process.env.REACT_APP_IMAGE}${item?.avatar}`} />
                )}
              </IconButton>
            </Grid>
            <Grid item xs={12} md={8}>
              <Stack spacing={3}>
                <RHFTextField name="fullname" label={t('editForm.fullname')} />
                <RHFTextField name="phone" label={t('editForm.phone')} />
                <RHFSelect name="role" label={t('editForm.role')}>
                  <MenuItem value={'manager'}>Manager</MenuItem>
                  <MenuItem value={'admin'}>Admin</MenuItem>
                  <MenuItem value={'recruit'}>Recruit</MenuItem>
                  <MenuItem value={'employee'}>Employee</MenuItem>
                  <MenuItem value={'cskh'}>CSKH</MenuItem>
                </RHFSelect>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">{t('save')}</Button>
          <Button type="button" color="error" onClick={onClose}>
            {t('close')}
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

const CreateDialog = ({ isOpen, onClose, createSubmit }) => {
  const [image, setImage] = useState();
  const [imageReview, setImagePreview] = useState();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { t } = useTranslation();

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required(t('createForm.vaUsername')).min(6, t('createForm.minUsername')),
    fullname: Yup.string().required(t('createForm.vaFullname')),
    password: Yup.string().required(t('createForm.vaPassword')).min(6, t('createForm.minPassword')),
    confirmPassword: Yup.string()
      .required(t('createForm.vaPasswordConfirm'))
      .oneOf([Yup.ref('password'), null], t('createForm.notMatch')),
    phone: Yup.string()
      .required(t('createForm.vaPhone'))
      .min(10, t('createForm.minPhone'))
      .max(10, t('createForm.minPhone')),
  });

  const handleAvatarChange = (e) => {
    const img = e.target.files[0];
    const review = URL.createObjectURL(img);
    setImagePreview(review);
    setImage(img);
  };

  const defaultValues = {
    username: '',
    fullname: '',
    phone: '',
    password: '',
    confirmPassword: '',
    role: 'manager',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleOnSubmit = (data) => {
    createSubmit(data, image);
  };

  return (
    <Dialog fullWidth={Boolean(true)} maxWidth={'md'} open={isOpen}>
      <DialogTitle>{t('createForm.title')}</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} container justifyContent={'center'} alignItems={'center'}>
              <IconButton
                sx={{
                  width: '200px',
                  height: '200px',
                  overflow: 'hidden',
                  ':hover': {
                    bgcolor: 'transparent',
                  },
                }}
                color="default"
                aria-label="upload picture"
                component="label"
              >
                <input hidden accept="image/*" type="file" onChange={handleAvatarChange} />
                {imageReview && <Image sx={{ overflow: 'hidden' }} src={imageReview} />}
                {!imageReview && <Image sx={{ overflow: 'hidden' }} src={`/static/noimage.jpeg`} />}
              </IconButton>
            </Grid>
            <Grid item xs={12} md={8}>
              <Stack spacing={3}>
                <RHFTextField name="username" label={t('createForm.username')} />
                <RHFTextField name="fullname" label={t('createForm.fullname')} />
                <RHFTextField name="phone" label={t('createForm.phone')} />
                <RHFTextField
                  name="password"
                  label={t('createForm.password')}
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <RHFTextField
                  name="confirmPassword"
                  label={t('createForm.confirmPassword')}
                  type={showConfirmPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                          <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <RHFSelect name="role" label={t('createForm.role')}>
                  <MenuItem value={'manager'}>Manager</MenuItem>
                  <MenuItem value={'admin'}>Admin</MenuItem>
                  <MenuItem value={'recruit'}>Recruit</MenuItem>
                  <MenuItem value={'employee'}>Employee</MenuItem>
                  <MenuItem value={'cskh'}>CSKH</MenuItem>
                </RHFSelect>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">{t('save')}</Button>
          <Button type="button" color="error" onClick={onClose}>
            {t('close')}
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
